export class StudentUserListView {
    suu_suid:                    number;
    suu_userid:                  string;
    suu_password:                string;
    suu_active:                  boolean;

}
